import type { Briefing, BriefingTodayResponse } from '@greeniq/shared';
import { api } from './client.js';

export function getTodayBriefing(courseSlug: string): Promise<BriefingTodayResponse> {
  return api.get<BriefingTodayResponse>(`/courses/${courseSlug}/briefings/today`);
}

export interface BriefingHistoryResponse {
  briefings: Briefing[];
  days: number;
}

export function getBriefingHistory(
  courseSlug: string,
  days = 14,
): Promise<BriefingHistoryResponse> {
  return api.get<BriefingHistoryResponse>(
    `/courses/${courseSlug}/briefings/history?days=${days}`,
  );
}

export type BriefingFeedbackRating = 'up' | 'down';

export interface BriefingFeedbackResponse {
  feedback: {
    id: number;
    briefingItemId: number;
    userId: number;
    rating: BriefingFeedbackRating;
    note: string | null;
    createdAt: string;
  };
}

export function sendBriefingFeedback(
  courseSlug: string,
  itemId: number,
  rating: BriefingFeedbackRating,
  note?: string,
): Promise<BriefingFeedbackResponse> {
  return api.post<BriefingFeedbackResponse>(
    `/courses/${courseSlug}/briefings/items/${itemId}/feedback`,
    { rating, note },
  );
}

export function regenerateBriefing(
  courseSlug: string,
): Promise<{ status: string; forDate?: string }> {
  return api.post<{ status: string; forDate?: string }>(
    `/courses/${courseSlug}/briefings/regenerate`,
  );
}
